"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectParticipantsScreen = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _pluralize = _interopRequireDefault(require("pluralize"));
var _utils = require("../../../utils");
var _ = require("../..");
var _CubbyFooter = _interopRequireDefault(require("../CubbyFooter"));
var _SelectParticipants = require("./SelectParticipants");
var _useManagerAppointmentCubby = require("../useManagerAppointmentCubby");
var _utils2 = require("../utils");
var _SelectAppointmentType = require("./SelectAppointmentType");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var TransitionOption = /*#__PURE__*/function (TransitionOption) {
  TransitionOption[TransitionOption["BookSingle"] = 0] = "BookSingle";
  TransitionOption[TransitionOption["BookRecurring"] = 1] = "BookRecurring";
  return TransitionOption;
}(TransitionOption || {});
var getAppointmentOptionProps = function getAppointmentOptionProps(_ref) {
  var user = _ref.user,
    patient = _ref.patient,
    clinician = _ref.clinician,
    recurringRule = _ref.recurringRule;
  var empty = {
    appointmentOption: undefined,
    transition: undefined
  };
  if ((0, _lodash.isEmpty)(patient) || (0, _lodash.isEmpty)(clinician)) {
    return empty;
  }
  if ((0, _utils.isPhysician)(clinician)) {
    return {
      // If user is physician, no need to describe appointment type
      appointmentOption: function appointmentOption() {
        return /*#__PURE__*/_react.default.createElement("p", null, (0, _utils.isPhysician)(user) ? '' : "Members can only book one-off appointments with ".concat((0, _pluralize.default)((0, _utils.getRoleNameLower)(_utils.UserRoles.Doctor)), "."));
      },
      transition: TransitionOption.BookSingle
    };
  }
  if ((0, _utils.isTherapist)(clinician)) {
    if (!(0, _lodash.isEmpty)(recurringRule)) {
      return {
        appointmentOption: function appointmentOption() {
          return /*#__PURE__*/_react.default.createElement("p", null, "This member already has a recurring appointment on ", (0, _utils.formatRecurringRule)(recurringRule), ". You can still book one-off appointments with them.");
        },
        transition: TransitionOption.BookSingle
      };
    }
    return {
      appointmentOption: function appointmentOption(value, setValue) {
        return /*#__PURE__*/_react.default.createElement(_SelectAppointmentType.SelectAppointmentType, {
          value: value,
          onSelect: setValue
        });
      }
    };
  }
  return empty;
};
var SelectParticipantsScreen = function SelectParticipantsScreen() {
  var _useAuth = (0, _.useAuth)(),
    user = _useAuth.user;
  var _useManagerAppointmen = (0, _useManagerAppointmentCubby.useManagerAppointmentCubby)(),
    patient = _useManagerAppointmen.patient,
    clinician = _useManagerAppointmen.clinician,
    transition = _useManagerAppointmen.transition;
  var _useState = (0, _react.useState)(patient),
    _useState2 = _slicedToArray(_useState, 2),
    selectedPatient = _useState2[0],
    setSelectedPatient = _useState2[1];
  var _useState3 = (0, _react.useState)(clinician),
    _useState4 = _slicedToArray(_useState3, 2),
    selectedClinician = _useState4[0],
    setSelectedClinician = _useState4[1];
  var _useState5 = (0, _react.useState)(_utils2.AppointmentType.OneOff),
    _useState6 = _slicedToArray(_useState5, 2),
    appointmentType = _useState6[0],
    setAppointmentType = _useState6[1];
  var recurringRule = (0, _utils2.getRecurringRuleFromProps)({
    patient: selectedPatient
  });
  var props = getAppointmentOptionProps({
    user: user,
    patient: selectedPatient,
    clinician: selectedClinician,
    recurringRule: recurringRule
  });
  var handleAction = function handleAction() {
    var payload = {
      selectedPatient: selectedPatient,
      selectedClinician: selectedClinician
    };
    props.transition === TransitionOption.BookRecurring ? transition('bookRecurring', payload) : props.transition === TransitionOption.BookSingle ? transition('bookSingle', payload) :
    // If no pre-determined transition, user was asked to choose appointment type
    appointmentType === _utils2.AppointmentType.Recurring ? transition('bookRecurring', payload) : transition('bookSingle', payload);
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "px-[24px] flex flex-col gap-y-[24px]"
  }, /*#__PURE__*/_react.default.createElement(_SelectParticipants.SelectParticipants, {
    selectedPatient: selectedPatient,
    selectedClinician: selectedClinician,
    includeRecurringRules: true,
    onClinicianSelect: setSelectedClinician,
    onPatientSelect: setSelectedPatient
  }), props.appointmentOption && props.appointmentOption(appointmentType, setAppointmentType), /*#__PURE__*/_react.default.createElement(_CubbyFooter.default, {
    actionText: "Continue",
    actionDisabled: !(selectedPatient && selectedClinician),
    onAction: handleAction,
    onCancel: function onCancel() {
      return transition('cancel');
    }
  }));
};
exports.SelectParticipantsScreen = SelectParticipantsScreen;